import { c as _c } from "react-compiler-runtime";
import { useEffect } from 'react';
import Raven from 'raven-js';
import { useGetTourQuery, useUpsertTourMutation } from '../../__generated__/chirp/com/hubspot/onboarding/tours/rpc/ToursRpc.hooks';
import { TourCompletionStatus } from '../constants/TourCompletionStatus';
import { isOnboardingTourSeleniumRunning } from '../utils/env';
export default function useTourStatus(t0) {
  "use memo";

  const $ = _c(20);
  const {
    tourId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isOnboardingTourSeleniumRunning();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isRunningOnboardingTourTest = t1;
  let t2;
  if ($[1] !== tourId) {
    t2 = {
      variables: {
        tourKey: tourId
      },
      skip: isRunningOnboardingTourTest
    };
    $[1] = tourId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data,
    loading,
    error
  } = useGetTourQuery(t2);
  const [upsertTour] = useUpsertTourMutation();
  let t3;
  let t4;
  if ($[3] !== error) {
    t3 = () => {
      if (error) {
        Raven.captureException(error, {
          fingerprint: ["error fetching the tour status"]
        });
      }
    };
    t4 = [error];
    $[3] = error;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[6] !== data || $[7] !== loading || $[8] !== tourId || $[9] !== upsertTour) {
    t5 = () => {
      if (isRunningOnboardingTourTest || loading || !data) {
        return;
      }
      if (data.status !== TourCompletionStatus.COMPLETE) {
        upsertTour({
          variables: {
            tourKey: tourId,
            status: TourCompletionStatus.COMPLETE
          }
        }).catch(_temp);
      }
    };
    t6 = [loading, data, tourId, isRunningOnboardingTourTest, upsertTour];
    $[6] = data;
    $[7] = loading;
    $[8] = tourId;
    $[9] = upsertTour;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  if (isRunningOnboardingTourTest) {
    let t7;
    if ($[12] !== tourId) {
      t7 = {
        tourStatus: {
          tourKey: tourId,
          status: TourCompletionStatus.COMPLETE
        },
        loading: false
      };
      $[12] = tourId;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    return t7;
  }
  let t7;
  if ($[14] !== data || $[15] !== tourId) {
    t7 = data ? {
      tourKey: data.tourKey,
      status: data.status
    } : {
      tourKey: tourId,
      status: TourCompletionStatus.INCOMPLETE
    };
    $[14] = data;
    $[15] = tourId;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const tourStatus = t7;
  let t8;
  if ($[17] !== loading || $[18] !== tourStatus) {
    t8 = {
      tourStatus,
      loading
    };
    $[17] = loading;
    $[18] = tourStatus;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp(err) {
  Raven.captureException(err, {
    fingerprint: ["error updating the tour status"]
  });
}